import React from "react";
import "./ventureRyteCTASection.scss";
import PracticeCTASection from "../shared/PracticeCTASection";

const VentureRyteCTASection = ({ onPrimaryClick }) => (
  <PracticeCTASection
    sectionClassName="ventureryte-cta-section"
    heading="Start Your VC 2.0 Journey"
    subtitle="Build smarter. Scale faster. Raise better."
    welcomeText="Welcome to Venture Capital 2.0"
    buttonLabel="Book a VC 2.0 Strategy Call"
    onPrimaryClick={onPrimaryClick}
  />
);

export default VentureRyteCTASection;
